<template>
    <div
        class="merchant-identity"
        :class="[`merchant-identity--${variant}`]"
        :style="containerStyle"
        tabindex="-1"
    >
        <template v-if="resolvedHasLogo">
            <img :src="resolvedLogo" alt="" tabindex="-1" />
        </template>

        <template v-else-if="showTextFallback">
            {{ merchantTextLogo }}
        </template>
    </div>
</template>

<script>
    import { contrastColor } from 'contrast-color';
    import { mapGetters, mapState } from 'vuex';

    export default {
        props: {
            variant: {
                type: String,
                default: 'summary',
                validator: value => ['summary', 'header'].includes(value)
            },
            logoSource: {
                type: String,
                default: 'legacy',
                validator: value => ['legacy', 'new'].includes(value)
            },
            showTextFallback: {
                type: Boolean,
                default: true
            },
            forceHasLogo: {
                type: Boolean,
                default: null
            }
        },

        computed: {
            ...mapGetters({
                merchantTextLogo: 'preorder/getMerchantTextLogo',
                legacyMerchantLogo: 'merchantLayout/getLogoUrl',
                newMerchantLogo: 'merchantLayout/getNewLogoUrl'
            }),

            ...mapState({
                hasLogo: state => state.merchantLayout.HasLogo,
                backgroundColor: state => state.merchantLayout.BackgroundColor
            }),

            resolvedHasLogo() {
                return this.forceHasLogo === null ? this.hasLogo : this.forceHasLogo;
            },

            resolvedLogo() {
                return this.logoSource === 'new' ? this.newMerchantLogo : this.legacyMerchantLogo;
            },

            containerStyle() {
                if (this.variant !== 'summary') {
                    return {};
                }

                const bgColor = this.resolvedHasLogo ? 'F2F4F8' : this.backgroundColor || '5C6BC0';

                return {
                    backgroundColor: `#${bgColor}`,
                    color: contrastColor({ bgColor: `#${bgColor}` })
                };
            }
        }
    };
</script>

<style lang="scss" scoped>
    .merchant-identity {
        display: flex;
        align-items: center;
        justify-content: center;
        flex: 0 0 auto;
        overflow: hidden;
    }

    .merchant-identity--summary {
        width: 48px;
        height: 48px;
        border-radius: 50%;
        color: #FFFFFF;
        font-size: 16px;
        font-weight: 700;
    }

    .merchant-identity--summary img {
        max-width: 100%;
        max-height: 100%;
    }

    .merchant-identity--header img {
        height: auto;
        max-height: 64px;
        max-width: 140px;
    }
</style>